import { render, staticRenderFns } from "./GetOffersLimit.vue?vue&type=template&id=31d431c4&"
import script from "./GetOffersLimit.vue?vue&type=script&lang=js&"
export * from "./GetOffersLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports